const resetFiltersEnvironment = () => {
  localStorage.removeItem('contact_filters');
  localStorage.removeItem('interaction_filters');
  localStorage.removeItem('proposal_filters');
};

export default resetFiltersEnvironment;
